<template>
  <div>
    <router-link
      :to="{
        name: 'search',
        query: {
          category: data.product_category_slug.toLowerCase(),
          type: 'product',
        },
      }"
      text
      class="text-deco d-none d-md-block"
    >
      <v-card
        outlined
        class="product-category rounded-lg text-body-2 mb-3 border-yellow"
        height="75"
        v-if="data"
      >
        <v-row class="pl-3 d-flex align-center">
          <v-col cols="4" class="py-0 d-flex align-center">
            <v-img :src="data.product_category_image"></v-img>
          </v-col>
          <v-col cols="8" class="py-0 d-flex align-center">
            <div
              class="text-capitalize black--text category-title text-elipsis"
            >
              {{ data.product_category_name }}
            </div>
          </v-col>
        </v-row>
      </v-card>
    </router-link>
    <router-link
      :to="{
        name: 'search',
        query: {
          category: data.product_category_slug.toLowerCase(),
          type: 'product',
        },
      }"
      text
      class="text-deco d-block d-md-none "
    >
      <v-card class="rounded-lg border-none" outlined height="90">
        <div class="mt-3  ">
          <v-img
            width="30"
            height="30"
            class="rounded-lg mx-auto"
            :src="data.product_category_image"
          ></v-img>
          <div
            class="pt-2 text-body-2 text-center black--text font-weight-bold text-elipsis text-description"
          >
            {{ data.product_category_name }}
          </div>
        </div>
      </v-card>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>

<style lang="scss" scoped>
.text-elipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.border-none {
  border: none;
}
.text-description{
    font-size: 11px !important;
}
@media (min-width: 961px) {
  .text-elipsis {
    -webkit-line-clamp: 2;
  }
}
</style>
